/**
 * GUMSHOE — frozen world coordinate conventions and shared constants.
 * Y-up, meters. See CONTRACTS.md "Coordinate Conventions".
 */
import type { NoirRenderConfig, Vec3 } from './types'

/** The street runs along Z. */
export const STREET_Z_MIN = -40
export const STREET_Z_MAX = 40
export const STREET_WIDTH = 12

/** Office interior occupies x > OFFICE_X_THRESHOLD. */
export const OFFICE_X_THRESHOLD = 30
/** The office door sits on the street's east wall. */
export const OFFICE_DOOR_POSITION: Vec3 = { x: 30, y: 0, z: 0 }

/** Player eye height in meters. */
export const PLAYER_EYE_HEIGHT = 1.7
/** Spawn at the south end of the street, facing -Z (yaw 0). */
export const PLAYER_SPAWN_POSITION: Vec3 = { x: 0, y: PLAYER_EYE_HEIGHT, z: 35 }
export const PLAYER_SPAWN_YAW = 0
export const PLAYER_SPAWN_PITCH = 0

/** Fixed simulation timestep, seconds (60 Hz). */
export const FIXED_TIMESTEP = 1 / 60
/** Clamp for frame delta to avoid spiral-of-death after tab suspension. */
export const MAX_FRAME_DELTA = 0.25

export const DEFAULT_NOIR_RENDER_CONFIG: NoirRenderConfig = {
  // Deep blue-grey, not pure black — distant geometry fades instead of
  // vanishing, and rooflines separate from sky.
  fogColor: 0x0a0c12,
  // Layered-depth exponential fog: far lamps stack as planes, near frame
  // keeps its black contrast (QA round 2: 0.028 crushed the office to grey).
  fogDensity: 0.02,
  // Hand grade (round 4): 3.8 flattened every surface to mid-grey — the
  // pools-of-light-in-darkness ratio is the entire noir read.
  toneMappingExposure: 2.3,
  grainIntensity: 0.22,
  vignetteStrength: 0.62,
  maxPixelRatio: 2
}
